import { render, staticRenderFns } from "./Joingroup.vue?vue&type=template&id=2fc3bf10&scoped=true&"
import script from "./Joingroup.vue?vue&type=script&lang=js&"
export * from "./Joingroup.vue?vue&type=script&lang=js&"
import style0 from "./Joingroup.vue?vue&type=style&index=0&id=2fc3bf10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc3bf10",
  null
  
)

export default component.exports